/* global BUILD_HASH,CLIENT_VERSION */
import debounce from 'lodash/debounce';
import {
    getState,
} from '~shared/utils/state';
import {
    ssDispatch,
} from '~SpectateStore';
import {
    setBuildInfoEnabled,
} from '~SpectateStore/slices/clientStateSlice';
import {
    getWrapperPageCorrelationId,
} from '~shared/utils/user';

const LATEST_HASH_STATE_KEY = 'client:buildHash:latest';
const NEXT_CLICK_THRESHOLD = 500;

const clicksManager = {
    goal: 5,
    cnt: 0,
    dbncd: debounce(cb => cb(), NEXT_CLICK_THRESHOLD),
    reset() {
        this.cnt = 0;
    },
    increment() {
        this.cnt++;
        this.dbncd(() => this.reset()); // Reset counter debounced.

        return this;
    },
    onGoalReached(callback) {
        if (this.cnt >= this.goal) {
            callback();
        }
    },
};

const updateAvailability = (isEnabled) => ssDispatch(
    setBuildInfoEnabled(isEnabled)
);

const enableBuildInfo = () => updateAvailability(true);
export const disableBuildInfo = () => updateAvailability(false);

export const incrementBuildInfoClick = () => {
    clicksManager
        .increment()
        .onGoalReached(enableBuildInfo);
};

export const getClientVersion = () => CLIENT_VERSION;
export const getClientBuildHash = () => BUILD_HASH;
const getLatestBuildHash = () => getState(LATEST_HASH_STATE_KEY);
const getSsrBuildHash = () => window.spectateBuildHash;

export const buildHashesMatcher = () => {
    const latestHash = getLatestBuildHash();
    const clientHash = getClientBuildHash();
    const ssrHash = getSsrBuildHash();

    const isMatch = latestHash === clientHash && clientHash === ssrHash;
    let mismatches = [];
    if (!isMatch) {
        mismatches = [
            latestHash !== clientHash && 'latest|client',
            latestHash !== ssrHash && 'latest|ssr',
            clientHash !== ssrHash && 'client|ssr',
        ].filter(Boolean);
    }

    return {
        isMatch,
        mismatches,
        latestHash,
        clientHash,
        ssrHash,
    };
};

export const analyzeBuildHashes = () => {
    const { isMatch, mismatches, clientHash, latestHash, ssrHash } = buildHashesMatcher();
    if (!isMatch) {
        const pageCorrelationId = getWrapperPageCorrelationId();
        console.error( //eslint-disable-line
            'Spectate Build hashes mismatch',
            {mismatches, clientHash, latestHash, ssrHash, pageCorrelationId}
        );
    }
};
